import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { ValidateFiscalCodeFailure, ValidateFiscalCodeRequest, ValidateFiscalCodeSuccess } from './actions';
import { ValidationResponse } from '@models/swagger';

export const featureKey = 'validateFiscalCode';

export interface State {
  data: ValidationResponse | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: null,
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(ValidateFiscalCodeFailure, (state, { error }) => ({ ...state, data: null, error, loading: false })),
    on(ValidateFiscalCodeRequest, state => ({ ...state, error: null, loading: true })),
    on(ValidateFiscalCodeSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
